module.exports = __webpack_public_path__ + "static/img/kuanggong.3c7363aa.jpg";